import { filter, maxBy } from 'lodash-es';
import { AICodingJob, AICodingJobType } from 'services/backend/aiCodingJobs';

export function getJobButtonState(
  jobs: AICodingJob[] | undefined,
  jobType: AICodingJobType,
  waveId: number | null | undefined,
): boolean {
  if (!jobs || jobs.length === 0) {
    return false;
  }

  const filteredByType = filter(jobs, (job) => job.jobType === jobType);
  const filteredByWave = filter(filteredByType, (job) =>
    waveId === null || waveId === undefined ? true : job.waveId === waveId,
  );
  const latestJob = maxBy(filteredByWave, 'id');

  return latestJob?.status === 'PENDING' || latestJob?.status === 'IN_PROGRESS';
}
